import { fetchIssuesAction } from './actions';

export const initializeIssues = () => async dispatch => {
  const fetchIssueActionWithAdvertiserIds = fetchIssuesAction();
  await dispatch(fetchIssueActionWithAdvertiserIds);
};
